import React, { Component } from "react";
import superagent from "superagent";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";

const githubContentsUrl = "https://e8e92kgig4.execute-api.us-west-2.amazonaws.com/dev/";

const groupLabels = {
  Dotnet: ".NET & C#",
  Java: "Java",
  OpenSource: "Open source"
};

class LearnToCode extends Component {
  constructor(props) {
    super(props);
    this.state = { readmes: props.GithubReadmes || {}, content: {}, loading: {} };
    window.clickLog("load", "LearnToCode");
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ readmes: nextProps.GithubReadmes || {} });
  }

  loadNotes = (key, url) => {
    if (this.state.content[key] || this.state.loading[key]) return;
    this.setState((state) => ({ loading: { ...state.loading, [key]: true } }));
    superagent
      .post(githubContentsUrl)
      .send({ url })
      .set("Accept", "application/json")
      .end((error, response) => {
        let html = "";
        if (!error && response && response.text) {
          try {
            const data = JSON.parse(response.text);
            html = data.contentHTML || "";
          } catch (ignored) {
            html = "";
          }
        }
        this.setState((state) => ({
          content: { ...state.content, [key]: html },
          loading: { ...state.loading, [key]: false }
        }));
      });
  };

  renderResource = (resource) => {
    const { key, link, name } = resource;
    const content = this.state.content[key];
    const loading = this.state.loading[key];
    return (
      <Accordion allowZeroExpanded key={key} className="resource-accordion">
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton onClick={() => this.loadNotes(key, link)}>
              <span>{name}</span>
              <span className="resource-accordion__hint">Open notes</span>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="resource-panel">
              <p>Reference notes from the CodeAndTech learning library.</p>
              <div className="resource-panel__actions">
                <a href={link} target="_blank" rel="noopener noreferrer">Open README ↗</a>
              </div>
              {loading && <p className="resource-panel__status">Loading notes…</p>}
              {!loading && !content && <p className="resource-panel__status">The full README can be opened with the link above.</p>}
              {content && <div className="resource-panel__content" dangerouslySetInnerHTML={{ __html: content }} />}
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    );
  };

  render() {
    const readmes = this.state.readmes;
    const groups = Object.keys(groupLabels).filter((key) => Array.isArray(readmes[key]) && readmes[key].length);
    if (!groups.length) return <div className="learning-page"><p>Loading learning notes…</p></div>;

    return (
      <div className="learning-page">
        <section className="page-intro page-intro--compact">
          <p className="page-kicker">CODEANDTECH LIBRARY</p>
          <h1>Learn to code.</h1>
          <p>Open any topic to preview its notes, or use the README link to work through the complete material on GitHub.</p>
        </section>
        <div className="learning-groups">
          {groups.map((group) => (
            <section className="learning-group" key={group}>
              <h2>{groupLabels[group]}</h2>
              {readmes[group].map(this.renderResource)}
            </section>
          ))}
        </div>
      </div>
    );
  }
}

export default LearnToCode;
